import React, { Component } from 'react'
import TextInput from '../../components/inputs/TextInput'
import RadioButton from '../../components/membership/membershipTaskList/RadioButton'
import DatePicker from '../../components/datePicker/DatePicker'
import ImageCropperWithUpload from '../../components/ImageUpload/UploadImage'
import CPASMemberServices from "../../services/axiosServices/apiServices/CPASMemberServices";
import SwalServices from '../../services/swalServices/SwalServices'
import { checkParameters, decryptionAPI } from '../../utils/Encryption'
import { getAuthProps } from '../../utils/AuthenticationLibrary'
import moment from "moment";
import ButtonLoader from "../../components/common/buttonLoader/ButtonLoader";
import { CommonValidationMessages } from '../../utils/Messages'
import { isValidForm, validate } from '../../utils/validation/CommonValidator'
import ValidationText from '../../utils/validation/ValidationText'
import { saveAs } from 'file-saver';
import { CommonSuccessMessages } from "../../utils/Messages";

const InterviewValidationRules = {
  name: [
    {
      type: "require",
      message: CommonValidationMessages.FieldRequired.replace("{0}", "Interviewer Name"),
    }
  ],
  email: [
    {
      type: "require",
      message: CommonValidationMessages.FieldRequired.replace("{0}", "Email Address"),
    },
    {
      type: "email",
      message: CommonValidationMessages.FieldRequired.replace("{0}", "valid email address"),
    }
  ],
  ncSignedOn: [
    {
      type: "require",
      message: CommonValidationMessages.FieldRequired.replace("{0}", "NC signed on date"),
    }
  ],
  interviewLink: [
    {
      type: "require",
      message: CommonValidationMessages.FieldRequired.replace("{0}", "Interview link"),
    }
  ]
}

export default class CpasInterview extends Component {

  constructor(props) {
    super(props);
    this.CPASMemberServices = new CPASMemberServices();
    this.swalServices = new SwalServices();
    this.state = {
      updatedBy: 0,
      batchSN: 0,
      applicantsDataList: [],
      openInterviewModal: false,
      keyId: 0,

      assignInterviewDetails: [],
      commonInterviewDate: "",
      showNCModal: false,      // modal visibility
      modalRowIndex: null,     // which row button was clicked
      ncSignedOnInput: "",     // value from calendar
      zoolLinkInput: "",

      isLoading: false,
      isFieldDesabled: false,
      interviewPackageList: [
        { cpasRoleId: 1, role: "Lead Assessor", name: "", email: "", ncSignedOn: "", interviewLink: "", interviewDate: "", interviewTime: "", assessorLink: "", isFieldDisabled: false },
        { cpasRoleId: 2, role: "Assessor 1", name: "", email: "", ncSignedOn: "", interviewLink: "", interviewDate: "", interviewTime: "", assessorLink: "", isFieldDisabled: false },
        { cpasRoleId: 3, role: "Assessor 2", name: "", email: "", ncSignedOn: "", interviewLink: "", interviewDate: "", interviewTime: "", assessorLink: "", isFieldDisabled: false }
      ],

      validState: [
        { name: "", email: "", ncSignedOn: "", interviewLink: "" },
        { name: "", email: "", ncSignedOn: "", interviewLink: "" },
        { name: "", email: "", ncSignedOn: "", interviewLink: "" }
      ],
      interviewAssesorDetail: {
        interviewPackageId: 0,
        cpasRoleId: 1,
        role: "Lead Assessor",
        assessorName: "",
        email: "",
        ncSignedOn: "",
        interviewLink: ""
      },
      copiedIndex: null,
    };
  }
  componentDidMount() {

    let params = new URLSearchParams(window.location.search);
    let batchSN = params.get("");

    let cookie = getAuthProps();

    if (cookie) {
      this.setState({ updatedBy: cookie.adminUserId });
    }

    if (batchSN && (batchSN = checkParameters(batchSN, "Number"))) {

      if (batchSN > 0) {
        this.setState({ batchSN }, () => {
          this.GetCPASInterviewDetailsByBatchId(batchSN);
        });
      }
    }
  }

  setOpenProfappModal = (flag, index) => {
    const row = this.state.interviewPackageList[index];

    this.setState({
      openInterviewModal: flag,
      keyId: index,
      ncSignedOnInput: row?.ncSignedOn || "",
      zoolLinkInput: row?.interviewLink || ""
    });
  };

  saveModalData = (key) => {
    let isValid = this.validateRow(key)
    if (isValid) {
      const { keyId, ncSignedOnInput, zoolLinkInput } = this.state;
      let updatedList = [...this.state.interviewPackageList];

      if (updatedList[keyId]) {
        updatedList[keyId].ncSignedOn = ncSignedOnInput;
        updatedList[keyId].interviewLink = zoolLinkInput;
      }

      this.setState({
        interviewPackageList: updatedList,
        openInterviewModal: false
      }, () => {
        this.swalServices.Success("Details updated successfully");
      });
    }
    this.setState({ openInterviewModal: false })

  };

  isValidateAllFields = (section) => {
    if (section === "Interview_Fields") {

      let validState = [];
      let isValid = true;

      this.state.interviewPackageList.forEach((item, index) => {

        validState[index] = {};

        Object.keys(InterviewValidationRules).forEach((key) => {

          const fieldRules = InterviewValidationRules[key];
          const fieldValue = item?.[key] || "";

          let error = "";

          for (let rule of fieldRules) {
            if (rule.type === "require") {
              if (!fieldValue.trim()) {
                error = rule.message;
                isValid = false;
                break;
              }
            }
            if (rule.type === "email") {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

              if (fieldValue.trim() && !emailRegex.test(fieldValue)) {
                error = rule.message;
                isValid = false;
                break;
              }
            }
          }
          validState[index][key] = error;
        });
      });
      this.setState({ validState });
      return isValid;
    }
  };

  validateField = (key, section, index) => {
    if (section === "Interview_Fields") {

      let validState = [...this.state.validState];

      if (!validState[index]) {
        validState[index] = {};
      }

      const fieldRule = InterviewValidationRules[key];
      const fieldValue = this.state.interviewPackageList[index]?.[key];

      let error = "";
      if (fieldRule) {

        for (let rule of fieldRule) {
          if (rule.type === "require") {
            if (!fieldValue.trim()) {
              error = rule.message;
              break;
            }
          }
          if (rule.type === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (fieldValue.trim() && !emailRegex.test(fieldValue)) {
              error = rule.message;
              break;
            }
          }
        }
      }
      validState[index][key] = error;

      this.setState({ validState });
    }
  };

  validateRow = (index) => {

    let validState = [...this.state.validState];
    let interviewPackageList = [...this.state.interviewPackageList];

    let isValid = true;

    if (!validState[index]) {
      validState[index] = {};
    }

    const item = interviewPackageList[index];

    Object.keys(InterviewValidationRules).forEach((fieldKey) => {

      const fieldRules = InterviewValidationRules[fieldKey];
      const fieldValue =
        fieldKey === "ncSignedOn" && index === this.state.keyId
          ? (this.state.ncSignedOnInput || "")
          : (item?.[fieldKey] || "");
      let error = "";

      for (let rule of fieldRules) {

        if (rule.type === "require") {
          if (!fieldValue.trim()) {
            error = rule.message;
            isValid = false;
            break;
          }
        }

        if (rule.type === "email") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if (fieldValue.trim() && !emailRegex.test(fieldValue)) {
            error = rule.message;
            isValid = false;
            break;
          }
        }
      }

      validState[index][fieldKey] = error;
    });

    this.setState({ validState });

    return isValid;
  };


  GetCPASInterviewDetailsByBatchId = (BatchSN) => {
    this.CPASMemberServices.GetCPASInterviewDetailsByBatchId(BatchSN)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem) {

          let applicants = response.responseItem.responseContent;
          let apiPackageList = [];

          if (applicants && applicants.length > 0) {
            apiPackageList = applicants[0].packageList || [];
          }
          let fixedRows = [
            { role: "Lead Assessor", cpasRoleId: 1, name: "", email: "", ncSignedOn: "", interviewLink: "", assessorLink: "", isFieldDisabled: false },
            { role: "Assessor 1", cpasRoleId: 2, name: "", email: "", ncSignedOn: "", interviewLink: "", assessorLink: "", isFieldDisabled: false },
            { role: "Assessor 2", cpasRoleId: 3, name: "", email: "", ncSignedOn: "", interviewLink: "", assessorLink: "", isFieldDisabled: false }
          ];

          apiPackageList.forEach(apiItem => {

            const index = fixedRows.findIndex(
              x => x.cpasRoleId === apiItem.cpasRoleId
            );

            if (index !== -1) {
              fixedRows[index] = {
                ...fixedRows[index],
                name: apiItem.assessorName,
                email: apiItem.emailAddress,
                ncSignedOn: apiItem.ncSignedOn,
                interviewLink: apiItem.interviewLink,
                assessorLink: apiItem.assessorLink,
                isFieldDisabled: true
              };
            }
          });

          this.setState({
            applicantsDataList: applicants,
            interviewPackageList: fixedRows
          });
        }
        else {
          this.swalServices.Error(response.message);
        }
      });
  }

  handleChange = (e, index, field) => {

    const value = e.target ? e.target.value : e;

    let updatedList = [...this.state.interviewPackageList];
    updatedList[index][field] = value;

    this.setState({
      interviewPackageList: updatedList,
      ...(field === "ncSignedOn" && { ncSignedOnInput: value }),
      ...(field === "interviewLink" && { zoolLinkInput: value })
    });
  };

  saveInterviewPackageDetail = (key) => {
    let isValid = this.validateRow(key);

    if (isValid) {
      const { ncSignedOnInput, zoolLinkInput } = this.state;

      let interviewPackageList = [...this.state.interviewPackageList];
      interviewPackageList[key].ncSignedOn = ncSignedOnInput;
      interviewPackageList[key].interviewLink = zoolLinkInput;

      this.setState({ interviewPackageList });

      const rowData = interviewPackageList[key];

      let request = {
        interviewPackageId: rowData.interviewPackageId,
        assessorName: rowData.name,
        emailAddress: rowData.email,
        cpasRoleId: rowData.cpasRoleId,
        ncSignedOn: rowData.ncSignedOn,
        interviewLink: rowData.interviewLink,
        batchId: this.state.batchSN
      };

      this.swalServices.Confirm(
        CommonSuccessMessages.Confirm_AddText.replace("{0}", "record"),
        CommonSuccessMessages.Confirm_Submit.replace("{0}", "record"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      ).then((response) => {
        if (response) {
          this.CPASMemberServices.addInterviewAssesorDetail(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem?.responseContent) {

              this.GetCPASInterviewDetailsByBatchId(this.state.batchSN);
              this.swalServices.Success("Record is added.", "OK");

              interviewPackageList[key].isFieldDisabled = true;
              this.setState({
                interviewPackageList,
                openInterviewModal: false
              });
            }
          });
        }
      });
    }
  };

  resetInterviewForm = () => {
    this.setState({
      openInterviewModal: false,
      keyId: 0,
      modalRowIndex: null,
      ncSignedOnInput: "",
      zoolLinkInput: "",

      interviewPackageList: [
        {
          role: "Lead Assessor",
          name: "",
          email: "",
          ncSignedOn: "",
          interviewLink: "",
          interviewDate: "",
          interviewTime: "",
        },
        {
          role: "Assessor 1",
          name: "",
          email: "",
          ncSignedOn: "",
          interviewLink: "",
          interviewDate: "",
          interviewTime: "",
        },
        {
          role: "Assessor 2",
          name: "",
          email: "",
          ncSignedOn: "",
          interviewLink: "",
          interviewDate: "",
          interviewTime: "",
        }
      ]
    });
  };

  getCPASMemberFiles = (type, Filepath, cpasMemberId) => {
    let request = [
      this.state.cpasMemberid = cpasMemberId,
      type,
      Filepath
    ]
    this.setState({ isLoading: true });
    this.CPASMemberServices.GetCPASMemberFiles(request).then((response) => {
      if (response.data !== null && response.status === 200) {
        let formattedDate = moment(new Date()).format("DDMMYYYYHHmmss")
        let filename = "";
        filename = `${type}${formattedDate}`;
        const extension = Filepath.split('.').pop();
        let file = '';
        if (extension == 'pdf') {
          file = new Blob([response.data], { type: 'application/pdf' });
          URL.createObjectURL(file);
          window.open(URL.createObjectURL(file), "_blank");
          saveAs(file, `${filename}.${extension}`);
        } else {
          file = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          URL.createObjectURL(file);
          saveAs(file, `${filename}.${extension}`);
        }
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });

    });
  }

  copyToClipboard = (text, index) => {
    if (!text) return;

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.left = "-999999px";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    this.setState({ copiedIndex: index });

    setTimeout(() => {
      this.setState({ copiedIndex: null });
    }, 5000);
  };
  
  render() {
    return (
      <div>
        <div className="main-body-section">
          <div className="flex">
            <div className="relative flex flex-col flex-1 "></div>
          </div>
          <div className="bg-white px-8 pt-10 pb-12">
            <div className="grid grid-cols-12 gap-6 w-full">
              <div className='2xl:col-span-12 lg:col-span-12 sm:col-span-12 col-span-12'>
                <div className=''>
                  <span className='2xl:text-[21px] lg:text-[21px] md:text-[21px] sm:text-[21px] text-[18px] font-bold'>
                    Batch:{this.state.batchSN}
                  </span>
                  <p className='2xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[14px]'>We are currently assigning the interview for the following applicants.</p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-6 w-full mt-5">
              <div className='2xl:col-span-12 lg:col-span-12 sm:col-span-12 col-span-12'>
                <div className='send-interview-package'>
                  <div className="overflow-x-auto">
                    <table className="w-full bg-white shadow-lg rounded-sm  border-slate-200">
                      <thead className="table-bg text-xs font-semibold capitalize text-[#000000] border-t border-b border-slate-200 ">
                        <tr>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap  font-bold tble-th-txt text-left  w-[15%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Name
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap  font-bold tble-th-txt text-left w-[20%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Email
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap  font-bold tble-th-txt text-left w-[30%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Tier
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap font-bold tble-th-txt text-center w-[10%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Submission Date
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap font-bold tble-th-txt text-center w-[10%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Interview Date
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowra font-bold tble-th-txt text-left w-[15%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Interview Time
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowra font-bold tble-th-txt text-left w-[15%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-sm custom-tbody">
                        {this.state.applicantsDataList?.map((row, idx) => (
                          <tr className="custom-tbl-td" key={idx}>
                            <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[15%] tble-td-txt text-[#000000]">
                              {row.name}
                            </td>

                            <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[20%] tble-td-txt text-[#000000]">
                              {row.emailAddress}
                            </td>

                            <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[30%] tble-td-txt text-[#000000]">
                              {row.applicationTier}
                            </td>

                            <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[10%] tble-td-txt text-[#000000]">
                              {row.submissionDate ? moment(row.submissionDate).format("DD/MM/YYYY") : "-"}
                            </td>

                            <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[10%] tble-td-txt text-[#000000]">
                              {row.interviewDate ? moment(row.interviewDate).format("DD/MM/YYYY") : "-"}
                            </td>


                            <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[15%] tble-td-txt text-[#000000]">
                              {row.interviewTime}
                            </td>
                            <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[15%] tble-td-txt text-[#000000]">
                              <a href="#" className="text-blue-600 underline"
                                onClick={(e) => { this.getCPASMemberFiles('Upload_PPT', row.pptFilePath, row.cpasMemberId) }}
                              >
                                View PPT
                              </a>
                            </td>
                          </tr>
                        ))}

                        {this.state.applicantsDataList?.length === 0 && (
                          <tr>
                            <td
                              colSpan={6}
                              className="px-4 py-6 text-center text-slate-500"
                            >
                              No applicants found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className='2xl:col-span-12 lg:col-span-12 sm:col-span-12 col-span-12'>
                <div className='send-interview-package lg:pt-7'>
                  <div className="overflow-x-auto">
                    <table className="w-full bg-white shadow-lg rounded-sm  border-slate-200">
                      <thead className="table-bg text-xs font-semibold capitalize text-[#000000] border-t border-b border-slate-200 ">
                        <tr>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap  font-bold tble-th-txt text-left  w-[15%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Role
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap  font-bold tble-th-txt text-left w-[15%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Name
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap  font-bold tble-th-txt text-left w-[25%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Email Address
                          </th>
                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowrap font-bold tble-th-txt text-center w-[10%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            NC
                            Signed On
                          </th>

                          <th className="px-4 first:pl-5 last:pr-5 tbl-th whitespace-nowra font-bold tble-th-txt text-left w-[20%] border-r border-[#ffffff]  bg-[#D9D9D9] text-[#2D2D2D]">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-sm custom-tbody">
                        <>
                          {
                            this.state.interviewPackageList.map((item, index) => (
                              <tr key={index} className="custom-tbl-td">
                                <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap  w-[15%] tble-td-txt text-[#000000] ">
                                  {item.role}
                                </td>
                                <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap  w-[15%] tble-td-txt text-[#000000] ">
                                  <TextInput
                                    // value={'John'}
                                    value={item.name}
                                    handleChange={(e) => this.handleChange(e, index, "name")}
                                    onBlur={() =>
                                      this.validateField("name", "Interview_Fields", index)
                                    }
                                    disabled={item.isFieldDisabled}
                                  />
                                  {this.state.validState[index]?.name && (
                                    <div style={{ color: "red" }}>
                                      {this.state.validState[index].name}
                                    </div>
                                  )}
                                </td>
                                <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap  w-[25%] tble-td-txt text-[#000000] ">
                                  <TextInput
                                    // value={'John@gmail.com'}
                                    value={item.email}
                                    handleChange={(e) => this.handleChange(e, index, "email")}
                                    onBlur={() =>
                                      this.validateField("email", "Interview_Fields", index)
                                    }
                                    disabled={item.isFieldDisabled}
                                  />
                                  {this.state.validState[index]?.email && (
                                    <div style={{ color: "red" }}>
                                      {this.state.validState[index].email}
                                    </div>
                                  )}
                                </td>
                                <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap  w-[10%] tble-td-txt text-[#000000] ">
                                  {item.ncSignedOn ? moment(item.ncSignedOn).format("DD/MM/YYYY") : ""}
                                  {this.state.validState[index]?.ncSignedOn && item.ncSignedOn === "" && (
                                    <div style={{ color: "red" }}>
                                      {this.state.validState[index].ncSignedOn}
                                    </div>
                                  )}
                                </td>
                                <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap  w-[20%] tble-td-txt text-[#000000] ">
                                  <div className=''>
                                    <>
                                      {item.isFieldDisabled === true ? (
                                        <button
                                          onClick={() => this.copyToClipboard(item.assessorLink, index)}
                                          className="2xl:px-3 lg:px-2 py-2 blue"
                                        >
                                          <i className="fa fa-link" style={{ marginRight: "6px" }}></i>
                                          {this.state.copiedIndex === index ? "Link Copied" : "Copy Link"}
                                        </button>
                                      ) : (
                                        <>
                                          <button
                                            onClick={() => this.setOpenProfappModal(true, index)}
                                            className="2xl:px-5 lg:px-2 py-2 btn btn-blue-border border text-[#005B9C]"
                                          >
                                            <span className="font-semibold">NC Signed On</span>
                                          </button>

                                          {this.state.validState[index]?.interviewLink &&
                                            item.interviewLink === "" && (
                                              <div style={{ color: "red" }}>
                                                {this.state.validState[index].interviewLink}
                                              </div>
                                            )}
                                        </>
                                      )}
                                    </>


                                  </div>
                                </td>
                              </tr>
                            ))
                          }
                        </>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="grid grid-cols-12 gap-6 w-full mt-[30px]">
              <div className='2xl:col-span-12 lg:col-span-12 sm:col-span-12 col-span-12 mb-2'>
                <div className="flex items-center justify-end">
                  {this.state.isLoading ? (
                    <ButtonLoader />
                  ) : (
                    <button className="text-lg font-bold btn btn-blue text-white"
                      onClick={() => this.saveInterviewPackageDetail()}
                    >Submit
                    </button>
                  )}
                </div>
              </div>
            </div> */}
          </div>
        </div>
        {this.state.openInterviewModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold">Update Interview Details</h3>
                <button onClick={() => this.setState({ openInterviewModal: false })} className="text-gray-500 text-2xl">&times;</button>
              </div>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1">NC Signed On</label>
                  <DatePicker
                    value={this.state.ncSignedOnInput}
                    handleChange={(e) =>
                      this.setState({ ncSignedOnInput: e.target.value })
                    }
                    className="w-full"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Zoom Link</label>
                  <TextInput
                    placeholder="Enter Zoom Link"
                    value={this.state.zoolLinkInput}
                    handleChange={(e) => this.handleChange(e, this.state.keyId, "interviewLink")}
                  />
                </div>
              </div>
              <div className="mt-6 flex justify-end space-x-3">
                <button className="px-4 py-2 border rounded" onClick={() => this.setState({ openInterviewModal: false })}>Cancel</button>
                <button className="px-4 py-2 bg-blue-600 text-white rounded" onClick={() => this.saveInterviewPackageDetail(this.state.keyId)}>Save Changes</button>
                {/* this.saveModalData(this.state.keyId) */}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

